<template>
  <section v-if="reservationInfo && !isVisitor" id="check" :class="useClass">
    <div class="partner_info">
      <div class="reserve_info">
        {{ reservationDateHeaderLabel }}
        {{ reservationDateHeaderSubLabel }}
        {{ reservationCourseHeaderLabel }}
        <p>
          <strong>{{ ccName }}</strong>
        </p>
        <div class="refresh" @click="fetch" />
      </div>
    </div>
    <div class="partner_box">
      <dl class="dl_reserve_list">
        <dt>{{ $t("main.reservationNo") }}</dt>
        <dd>{{ reservationNo }}</dd>
        <dt>{{ $t("main.reservationState") }}</dt>
        <dd>
          <span :class="['state', reservationStateClass]">
            {{ reservationStateLabel }}
          </span>
        </dd>
        <dt>{{ $t("main.reservationMember") }}</dt>
        <dd>{{ reservationMemberNameAndPhoneNumber }}</dd>
        <dt>{{ $t("main.reservationChannel") }}</dt>
        <dd>{{ reservationChannel }}</dd>
        <dt>{{ $t("main.visitCount") }}</dt>
        <dd>
          {{
            visitCount === 4
              ? "3~4인"
              : $t("main.visitCountSuffix", [visitCount])
          }}
          <!-- <input
            v-for="count in [4, 3]"
            :key="count"
            :class="['btn_num_select', visitCount === count && 'active']"
            style="margin-left: 5px"
            type="button"
            :value="`${count}명`"
          /> -->
          <!-- @click="visitCount = count" -->
        </dd>
        <dt v-if="isBooker">
          {{ $t("main.reservationAvailableCancelDateTime") }}
        </dt>
        <dd v-if="isBooker">{{ reservationAvailableCancelDateTime }}</dd>
      </dl>
      <ul class="people_list">
        <li
          v-for="member in reservationCmpnList"
          :key="`member${member.sno}`"
          @click="onClickModifyPartner(member)"
        >
          <span
            :class="[
              'ico',
              reservationSexClass(member.sexCode),
              (reservationKind !== 'FIT' &&
                member.memberNo === reservationMemberNo) ||
              (reservationKind === 'FIT' &&
                (member.reprsntFlag || member.memberNo === reservationMemberNo))
                ? 'crown'
                : null,
            ]"
          />
          {{ member.cmpnName }}
          <a
            v-if="
              isBooker &&
              member.resveId &&
              !member.reprsntFlag &&
              !member.isCheckedIn
            "
            class="btn_people"
            data-animation="fade"
            @click.self="onClickDeletePartner(member.sno)"
          />
          <a v-if="member.isCheckedIn" class="ico_checkin" />
        </li>
        <li
          v-for="more in reservationCmpnMoreList"
          :key="`more${more.sno}`"
          @click="onClickAddPartner"
        >
          <a data-animation="fade">
            <span class="ico more" />
          </a>
        </li>
      </ul>
    </div>
    <div class="main_btn_wrap">
      <a
        v-html="goCheckInPageLabel"
        class="btn_basic btn_checkin"
        @click="onClickGoCheckInPage()"
      />
      <a
        v-if="reservationCmpnList.length > 0"
        v-text="'QR체크인'"
        class="btn_basic btn_qrcode"
        @click="onClickGoQrCodePage()"
      />
      <a
        class="btnBack"
        @click="goToGrpReservationList"
        v-if="isBooker && reservationKind === 'GRP'"
      >
        예약현황
      </a>
    </div>
    <partner-ok-popup
      v-if="isPartnerOkPopupOpened"
      @submit="onPartnerOkPopupSubmit"
    />
    <partner-register-popup
      v-if="isPartnerRegisterPopupOpened"
      ref="partnerRegisterPopup"
      @close="onPartnerRegisterPopupClose"
      @submit="onPartnerRegisterPopupSubmit"
    />
    <partner-modify-popup
      v-if="isPartnerModifyPopupOpened"
      ref="partnerModifyPopup"
      @close="onPartnerModifyPopupClose"
      @submit="onPartnerModifyPopupSubmit"
    />
    <partner-delete-popup
      v-if="isPartnerDeletePopupOpened"
      ref="partnerDeletePopup"
      @close="onPartnerDeletePopupClose"
      @submit="onPartnerDeletePopupSubmit"
    />
    <qrcode-create-popup
      v-if="isQrcodeCreatePopup"
      ref="qrcodeCreatePopup"
      @closeQrPopup="onCloseQrPopup"
    />
  </section>
</template>

<script>
import checkInMixin from "@/mixins/checkInMixin";
import geolocationMixin from "@/mixins/geolocationMixin";
import ProjectService from "@/service/ProjectService";
import { mapGetters } from "vuex";
import QrcodeCreatePopup from "@/components/reservations/popup/QrcodeCreatePopup.vue";
import { getCurrentSessionResveId } from "@/utils/session/SessionUtil";
import ProjectAPIError from "@/api/error/ProjectAPIError";

export default {
  name: "ReservationStatus",
  components: { QrcodeCreatePopup },
  mixins: [checkInMixin, geolocationMixin],
  props: {
    useClass: {
      type: [Object, Array, String],
      default: "check_bg",
    },
  },
  data() {
    return {
      reservationAvailableCancelDateTime: null,
      isQrcodeCreatePopup: false,
    };
  },
  async mounted() {
    await this.fetch();
  },
  computed: {
    ...mapGetters(["ccName"]),
    goCheckInPageLabel() {
      return this.isCheckedIn
        ? this.$t("main.checkInStatus")
        : `${this.$t("main.checkIn")}
           <span>|</span>
           ${this.$t("main.issuanceLockerKey")}`;
    },
  },
  methods: {
    async goToGrpReservationList() {
      await this.$router.push({
        name: "ReservationStatusByGroup",
        params: { reservationId: this.$route.params.reservationId },
      });
    },
    onClickGoQrCodePage() {
      if (this.checkInKey < 0) {
        this.confirm({
          content: this.$t("api.errorMessage.CANT_CHECK_IN_BOOKER"),
        });
        return;
      }
      const resveId = this.reservationCmpnList.find(
        (f) => f.sno === this.checkInKey
      ).resveId;
      this.isQrcodeCreatePopup = true;
      this.$nextTick(() => {
        this.$refs.qrcodeCreatePopup.show({
          sno: this.checkInKey,
          resveId,
        });
      });
    },
    onCloseQrPopup() {
      this.isQrcodeCreatePopup = false;
    },
    async onClickGoCheckInPage(isPassCheckIn = false) {
      if (this.isVisitor) return;
      await this.goCheckInPage(isPassCheckIn);
    },
    async goCheckInPage(isPassCheckIn = false) {
      try {
        const { tgResveConfirm } = await ProjectService.fetchReservation(
          getCurrentSessionResveId()
        );
        // 3부면 tgResveConfirm.prpayPayUseFlag = true
        if (tgResveConfirm.prpayPayUseFlag) {
          alert(`3부 티업 이용 고객님께서는\n프론트를 방문해 체크인 해주세요`);
          return;
        }
      } catch (e) {
        if (e instanceof ProjectAPIError) {
          const { status } = e.data;
          switch (status) {
            case "INVALID_URL":
              this.clearPhoneNumber();
              break;
          }
        }
        throw new Error(e);
      }
      const date = this.reservationDateHeaderLabel;
      const time = this.reservationDateHeaderSubLabel;
      const course = this.reservationCourseHeaderLabel;
      const count = this.visitCount;
      const query = `?date=${date}&time=${time}&course=${course}&count=${count}`;
      if (!isPassCheckIn && !this.isCheckedIn) {
        const geolocation = await this.getGeolocation();
        if (geolocation) {
          const status = await ProjectService.getEcoFrontCheckInValidation(
            this.reservationId,
            geolocation.longitude,
            geolocation.latitude
          );
          if (status === "OK") {
            await this.$router.push(
              `/reservations/${this.reservationId}/check-in?${query}`
            );
          }
          return;
        } else {
          await this.goSettingGpsGuidePage();
        }
      }
      await this.$router.push(
        `/reservations/${this.reservationId}/check-in-status?${query}`
      );
    },
  },
  /* 뒤로가기 버튼 클릭시 팝업 열린 상태면 팝업만 닫히도록 처리 */
  async beforeRouteLeave(to, from, next) {
    if (this.isPopupOpened) {
      this.closeAllPopup();
      const UUID = Math.round(Math.random() * 999999).toString();
      await this.$router.push(`${this.$route.path}?uuid=${UUID}`);
    }
    next();
  },
};
</script>
<style scoped>
.btnBack {
  margin-top: 10px;
  display: block;
  width: 100%;
  height: 60px;
  line-height: 58px;
  border: 1px solid #ccc;
  background-color: #ffffff;
  color: #4db4ac;
  font-size: 17px;
  text-align: center;
  border-radius: 4px;
  padding: 0 17px;
}
</style>
